module.exports = "pegasus_template/assets/test-fixture-car-front.jpg";